// components/shared/LoginFormFields.tsx
import React from "react";
import { EmailInput, PasswordInput, InputRow } from "./";
import { InputBindings } from "../../hooks";

interface LoginFormFieldsProps {
    emailBindings: InputBindings;
    passwordBindings: InputBindings;
    ErrorSummary: React.ComponentType;
    onPasswordEnter: () => void;
    showErrorSummary?: boolean;
}

export const LoginFormFields: React.FC<LoginFormFieldsProps> = ({ emailBindings, passwordBindings, ErrorSummary, onPasswordEnter, showErrorSummary = true }) => {
    return (
        <>
            {showErrorSummary && (
                <div className="mx-auto mb-3">
                    <ErrorSummary />
                </div>
            )}
            <InputRow>
                <EmailInput {...emailBindings} />
            </InputRow>
            <InputRow>
                <PasswordInput {...passwordBindings} onEnter={onPasswordEnter} />
            </InputRow>
        </>
    );
};
